import { UserClient, UserGridModel } from "@app/api2/api";
import { getInactiveFilter2, getLabFilter2 } from "@common/Utils";
import { PageHeader } from "@common/PageHeader";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { Link } from "react-router-dom";
import { useTranslation2 } from "../Contexts/TranslationContext2";
import { BPReactTable2, getFilterValue, useBpReactTable2 } from "../Common/DataTable/BPReactTable2";
import { BPContainer } from "@/components/bp/bpcontainer";

interface UsersProps {
    canCreateUser: boolean;
}

export const Users = (props: UsersProps) => {
    const client: UserClient = new UserClient();
    const t = useTranslation2();

    const usersTable = useBpReactTable2<UserGridModel>({
        queryKeyPrefix: 'Users',
        defaultSortingState: [{ id: 'name', desc: false }],
        query: async (paging, sorting, searchValue, filters) => {
            let showInactive = getFilterValue(filters, 'showInactive') ? true : false;
            let labId = getFilterValue(filters, 'labId') ?? null as any;
            if (labId == -1)
                labId = null;

            let pageData = await client.pageData(paging.pageSize, paging.pageIndex + 1, sorting[0]?.id, sorting[0]?.desc ? 'desc' : 'asc', showInactive, searchValue, labId);

            return { rowCount: pageData.totalRows, rows: pageData.items }
        },
        columnDefs: [
            getLabFilter2('labId', t.translations.common.labs),
            getInactiveFilter2('showInactive', t.translations.userView.showInactive),
            {
                id: 'name',
                header: t.translations.user.name,
                accessorFn: row => row.name,
                cell: cell => <Link to={buildUrl(AppRoutes.UserDetails, { userId: cell.row.original.id })}>{cell.row.original.name}</Link>,
                meta: { width: '20%' },
            },
            {
                id: 'email',
                header: t.translations.common.emailAddress,
                accessorFn: row => row.email,
                meta: { width: '20%' },
            },
            {
                id: 'roleList',
                header: t.translations.userView.roles,
                accessorFn: row => row.roleList,
                meta: { width: '25%' },
                enableSorting: false,
            },
            {
                id: 'labList',
                header: t.translations.common.labs,
                accessorFn: row => row.labList,
                enableSorting: false,
            }]
    });

    return (
        <BPContainer>
            <PageHeader header={t.translations.common.users}
                buttons={props.canCreateUser ? [
                    { label: t.translations.userView.create, to: buildUrl(AppRoutes.UserCreate, {}) }
                ] : []}
            />
            <BPReactTable2 {...usersTable} />
        </BPContainer>
    );

}

